export default __webpack_public_path__ + "static/media/77.2e73787c.jpg";